import React, {Component} from "react";
import {
  AGENT_INFO,
  AGENT_INFO_V01,
  RECOMMENDATION_CODE,
  APP_SECTION,
  PAGES
} from "../../../scripts/constants";
import {isValid, mygaSession} from "../../../scripts/myga-session";
import {saveApplication, startApplication, verifyAgentCode} from "../../../scripts/sync-manager";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {Button, Col, Container, Row} from "react-bootstrap";
import {charLimits, regex, NassauLog} from "../../../scripts/myga-utils";
import PopoverTooltip from "../../../components/PopoverTooltip";
import {Analytics} from "../../../scripts/analytics";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import GENERATOR from "../../../selenium-front-end/generator/Generator";

class AgentCode extends Component {
  
  constructor(props) {
    super(props);
    // setup default prev/next pages with props overrides
    // this.prevPage = props.prevPage || PAGES.pageGuestEmail; // 2021.07.14.ADivelbiss - commented in favor of PageManager page stack solution
    // this.nextPage = props.nextPage || PAGES.pageAppProcessOverview; // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
    
    // 2021.05.11.ADivelbiss - updates to pre-populate the page if an agent has already been validated
    // so that the the user can verify the proper agent.
    let agentInfo = mygaSession.getAgentInfo();
    
    this.state = {
      referralCode: isValid(agentInfo) ? agentInfo.referralCode : (this.props.agentReferralInfo.referralCode || ''),
      errorMessage: '',
      agentInfo: agentInfo,
      referralCodeValidated: isValid(agentInfo),
    };

    if (process.env.REACT_APP_TESTING) {
      this.state['canSkipAgentCodeVerify'] = true
    }
  }
  
  componentDidMount() {
    
    // 2021.07.14.ADivelbiss - will always go back to the email page
    // // check to see if we have a guest principal saved if not reset prev page to guest email
    // this.prevPage = mygaSession.getShowGuestEmailPage()?PAGES.pageGuestEmail:PAGES.pageDashboard;
  
    // Get the current application
    let app = mygaSession.getCurrentApp();
    if (app===null) {
      // request a new application from the backend
      startApplication()
          .then((data)=>{
            NassauLog("app: " + JSON.stringify(data));
            // Got it! OK to continue.
            // Validate the referral code if provided after getting the application
            if (this.props.agentReferralInfo && this.props.agentReferralInfo.referralCode) {
              this.setState({referralCode: this.props.agentReferralInfo.referralCode}, async () => {
                await this.checkReferralCode();
              });
            }
          })
          .catch((err) => {
            NassauLog(err);
            // TODO: Handle the error. Message popup?
          });
    } else  {
      // OK continue on.
      // Already have the application so Validate the referral code if provided
      if (this.props.agentReferralInfo && this.props.agentReferralInfo.referralCode) {
        this.setState({referralCode: this.props.agentReferralInfo.referralCode}, async () => {
          await this.checkReferralCode();
        });
      }
      // 2021.10.06.ADivelbiss - Since the default recommendation status for an agent is now
      // recommendation instead of referral, I'm commenting this code to leave the previously validated agent
      // information as is.  Resetting to RECOMMENDATION_CODE.none would make it a referral and it would
      // go do the shared queue.
      // else if (this.state.agentInfo && this.state.agentInfo.referralCode) {
      //   // 2021.09.30.ADivelbiss - if we're here then there was no agent referral code
      //   // or agent recommendation code in the url but we do have a previously entered
      //   // and validated agent.  However since there was no 'ar' code we need
      //   // to reset any possible recommendation code here
      //   let agentInfo = this.state.agentInfo;
      //   agentInfo[AGENT_INFO.recommendationCode] = RECOMMENDATION_CODE.none;
      //   NassauLog(`AgentCode.agentInfo: ${JSON.stringify(agentInfo,null,2)}`);
      //   this.setState({agentInfo: agentInfo});
      // }
    }
  }

  onNextPressed = async () => {
    await this.saveAgentInfo()

    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      if (this.state.referralCode !== '') {
        if (this.state.canSkipAgentCodeVerify) {
          await GENERATOR.stageManualActionList([
            {
              type: "WAIT_UNTIL_ELE_ID_LOCATED",
              id: "agentInfo",
              timeout: 10000
            }
          ])
        } else {
          await GENERATOR.stageManualActionList([
            {
              type: 'keys',
              id: 'referralCode',
              value: this.state.referralCode,
            },
            {
              type: "click",
              id: "verify"
            },
            {
              type: "wait",
              id: "agentInfo",
              timeout: 10000
            }
          ])
        }
      }
    }
  }
  
  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
  
    // 2022.04.13.ADivelbiss - restoring this to the original code.
    // allow user to move to next screen if the referral code was empty.
    if (!isValid(this.state.referralCode) || this.state.referralCode.length === 0) {
      return true;
    }
    // 2022.04.13.ADivelbiss - this code would allow the user to continue improperly in some cases.
    // if (isReferralCodeValid({[STORAGE_KEYS.AgentInfo]: this.state.agentInfo})) {
    //   return true;
    // }
  
    NassauLog(`referralCodeValidated: ${this.state.referralCodeValidated}`);
  
    if (!this.state.referralCodeValidated) {
      this.setState({
        errorMessage: 'Please enter a valid referral code or no code to proceed.'
      })
    }
  
    return this.state.referralCodeValidated;
    
  };
  
  saveAgentInfo = async () => {
    if (!isValid(this.state.referralCode) || this.state.referralCode.length === 0) {
      // 2021.08.13.ADivelbiss - clear the agent if no code was given.
      // clear the current agent if any
      mygaSession.setAgentInfo(null);
      mygaSession.setCurrentAppSectionData(APP_SECTION.referral,null);
      Analytics.setAgentReferralCode('(none)');
      await saveApplication(APP_SECTION.referral);
    } else if (isValid(this.state.agentInfo)) {
      mygaSession.setAgentInfo(this.state.agentInfo);
      mygaSession.setCurrentAppSectionData(APP_SECTION.referral,this.state.agentInfo);
      if (isValid(this.state.agentInfo.referralCode)) {
        Analytics.setAgentReferralCode(this.state.agentInfo.referralCode);
      } else {
        Analytics.setAgentReferralCode('(none)');
      }
    }
    else {
    }
    // Save the agent info in the current application
    await saveApplication(APP_SECTION.referral);
  

  };
  
  checkReferralCode = async (userInitiated = false) => {
      try {

       let data = await verifyAgentCode(this.state.referralCode);
        // let data = await verifyAgentCodeV01(this.state.referralCode);

        // 2021.06.15.ADivelbiss - Add the recommendation code determined in App.js
        // 2021.10.06.ADivelbiss - N.B. the default recommendation code for a valid agent should be RECOMMENDATION.default
        let agentInfo = data.referral;
        agentInfo[AGENT_INFO.recommendationCode] = userInitiated ? RECOMMENDATION_CODE.default : this.props.agentReferralInfo[AGENT_INFO.recommendationCode];
  
        NassauLog("Agent Referral: " + JSON.stringify(agentInfo));
        
        this.setState({
          agentInfo: agentInfo,
          referralCodeValidated: true,
          errorMessage: '',
        })

      } catch (e) {
        NassauLog("Agent Referral error: " + e);
        this.setState({
          agentInfo: null,
          referralCodeValidated: false,
          errorMessage: 'The code entered is not valid.',
        })
      }
  };
  
  verifyReferralCode = async () => {
    await this.checkReferralCode(true);
    if (process.env.REACT_APP_TESTING) {
      this.setState({...this.state, canSkipAgentCodeVerify: false})
    }
  }
  
  render() {
    return (
        <AppContentWrapper
            onNextPressed={this.onNextPressed}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}
        >
          
          <form className={'auth-form needs-validation'}
                ref={(form) => {
                  this.pageForm = form;
                }}>
  
  
            <Row className={'text-center'}>
    
              <div className={'col-8 offset-2 form-group pt-3'}>
                <label className={''} htmlFor={'referralCode'}>
                  Have a digital code?&nbsp;
                </label>
                {/*TODO: put in a string constant*/}
                <PopoverTooltip content={MYGAStrings.AgentCode_Tooltip}/>
                <input id="referralCode"
                       type="text"
                       className={'form-control text-center'}
                       value={this.state.referralCode}
                       style={{fontSize: 20, textTransform:"uppercase"}}
                       pattern={regex.referralCode}
                       maxLength={charLimits.referralCode}
                       placeholder={'Enter Code'}
                       onChange={e => {
                         this.setState({
                           referralCode: e.target.value.toUpperCase(),
                           referralCodeValidated: false,
                           errorMessage: ''
                         });
                       }}
                />
    
              </div>
  
            </Row>
            
            {
              (this.state.referralCode && this.state.referralCode.length>0 && !this.state.referralCodeValidated) && (
                  <Row className="text-center pt-3">
                    <Col>
                      <Button id={"verify"} variant="primary" onClick={this.verifyReferralCode}>
                        Verify
                      </Button>
                    </Col>
                  </Row>
              )
            }
            {
              (this.state.referralCode && this.state.referralCode.length>0 && this.state.referralCodeValidated) && (
                  <Container id={"agentInfo"}>
                    <Row className="text-center pt-3">
                      <Col>
                        Agent Information:
                      </Col>
                    </Row>
                    <Row>
                      <Col className="offset-md-1 col-md-10 offset-lg-3 col-lg-6">
                        <Row className="pb-1">
                          <Col md={3} className="">
                            Name:
                          </Col>
                          <Col md={9} >
                            {
                              isValid(this.state.agentInfo.name) ? this.state.agentInfo.name :
                                  `${this.state.agentInfo[AGENT_INFO_V01.firstName]} ${this.state.agentInfo[AGENT_INFO_V01.lastName]}`
                            }
                          </Col>
                        </Row>
                        <Row className="pb-1">
                          <Col md={3} className="">
                            Email:
                          </Col>
                          <Col md={9} >
                            {this.state.agentInfo.email}
                          </Col>
                        </Row>
                        <Row className="pb-1">
                          <Col md={3} className="">
                            Phone:
                          </Col>
                          <Col md={9} >
                            {
                              isValid(this.state.agentInfo.phone) ? this.state.agentInfo.phone : this.state.agentInfo[AGENT_INFO_V01.mobile]
                            }
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Container>
              )
            }
          
          </form>
        
        </AppContentWrapper>
    )
  }
  
}

export default AgentCode;